import React from "react";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import "react-h5-audio-player/lib/styles.css";
import { BACKGROUND_COLOR } from "../library-quote/libraryQuote";

// Components //
import CommentSection from "../comment-section/comment-section";
import LikeButton from "../../molecules/like-button/like-button";
import ShareButton from "../../molecules/share-button/share-button";
import BibliotecaRecommendation from "../biblioteca-recommentation/bibliotecaRecommendation";

// References //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Services //
import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";

// Styles //
import "./bibliotecaContent.scss";

const BibliotecaContent = (props: ReferenciaContenido) => {
    const { referenciaMultimedia: refMultimedia } = props;

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname: ''
    const tituloMultimediaFixed = removeAccents(props.referenciaMultimedia[0].tituloMultimedia).replace(/\s+/g, "").toLowerCase();

    const gtmBasedOnPathName = () =>{
        return `/${pathName.split('/')[2]}/${pathName.split('/')[3]}/` == `/${pathName.split('/')[2]}/biblioteca/` ?
            `gtm_compartir_interna_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
            :'';
    }


    return (
        <>
            <div className="o-biblioteca-content-social-wrapper">
                <div className="o-biblioteca-content-social">
                    <div className={`o-biblioteca-content-social-btns ${gtmBasedOnPathName()}`}>
                        <LikeButton
                            contentId={props.contentful_id}
                            contentType={CONTENT_TYPE_ARTICULO}
                        />
                        <ShareButton login={false} />
                    </div>
                    <hr />
                </div>
                <div className="o-biblioteca-content">
                    <div className="container">
                        <div className="o-biblioteca-content__container">
                            {refMultimedia[0].categoriaMultimedia == "Servicio de Empleo" && (
                                <div className="o-biblioteca-content__container__description">
                                    {contentfulRenderOptions(
                                        refMultimedia[0].descripcion.json, "wrapper-image"
                                    )}
                                </div>
                            )}
                            {refMultimedia[0].categoriaMultimedia == "Artículo" && (
                                <div className="o-biblioteca-content__container__description">
                                    {contentfulRenderOptions(
                                        refMultimedia[0].descripcion.json, "wrapper-image"
                                    )}
                                </div>
                            )}
                            {refMultimedia[0].categoriaMultimedia == "Podcast" && (
                                <div className="o-biblioteca-content__container__description">
                                    {refMultimedia[0].descripcion &&
                                        contentfulRenderOptions(
                                            refMultimedia[0].descripcion.json, "wrapper-image"
                                        )}
                                </div>
                            )}
                            {refMultimedia[0].categoriaMultimedia ==
                                "Historias que conectan" && (
                                <div className="o-biblioteca-content__container__description">
                                    {contentfulRenderOptions(
                                        refMultimedia[0].descripcion.json, "wrapper-image"
                                    )}
                                </div>
                            )}
                            {refMultimedia[0].categoriaMultimedia == "Webinar" && (
                                <div className="o-biblioteca-content__container__description">
                                    {refMultimedia[0].descripcion &&
                                        contentfulRenderOptions(
                                            refMultimedia[0].descripcion.json, "wrapper-image"
                                        )}
                                </div>
                            )}
                            {refMultimedia[0].categoriaMultimedia == "Proyecto" && (
                                <div className="o-biblioteca-content__container__description">
                                    {refMultimedia[0].descripcion &&
                                        contentfulRenderOptions(
                                            refMultimedia[0].descripcion.json, "wrapper-image"
                                        )}
                                </div>
                            )}
                        </div>
                        {refMultimedia[0].disclaimer && (
                            <div className={`o-biblioteca-content__disclaimer ${BACKGROUND_COLOR[refMultimedia[0].disclaimer.colorFondo]}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27.933" height="27.933" viewBox="0 0 27.933 27.933">
                                    <path id="informacion_7_" data-name="informacion (7)" d="M13.966,27.933A13.966,13.966,0,1,0,0,13.966,13.966,13.966,0,0,0,13.966,27.933Zm0-22.113a1.746,1.746,0,1,1-1.746,1.746A1.746,1.746,0,0,1,13.966,5.819ZM12.8,11.639h1.164a2.328,2.328,0,0,1,2.328,2.328v6.983a1.164,1.164,0,1,1-2.328,0V13.966H12.8a1.164,1.164,0,0,1,0-2.328Z" fill="#ee2b7c"/>
                                </svg>
                                <p>{refMultimedia[0].disclaimer.textoInspirador}</p>
                            </div>
                        )}
                    </div>
                </div>

                {refMultimedia[0].mostrarCarrusel && <BibliotecaRecommendation {...props}/>}
                {refMultimedia[0].mostrarSeccionComentarios && <CommentSection contentId={props.parentContentfulId} />}

            </div>
        </>
    );
};

export default BibliotecaContent;
